<section
  id="issues-filter"
  class="flex justify-between items-center w-full box-border gap-6"
  *ngIf="!displayLoader; else issuesFilterSkeleton"
>
  <div
    class="issues-filter-card p-4 rounded-lg flex-1 transition-all duration-300"
    *ngFor="let item of sortedData; let i = index"
    [ngClass]="[
      isCardDisabled(item.issueName)
        ? 'bg-neptune-color-neutral-300'
        : getCardColor(i),
      isCardDisabled(item.issueName)
        ? 'cursor-not-allowed text-neptune-color-fg-muted'
        : 'text-white',
    ]"
  >
    <div class="issues-filter-card-content flex flex-col gap-1">
      <section class="issues-filter-card-header flex justify-between">
        <span class="issues-filter-card-call-count text-3xl">
          {{ item.callCount }}
        </span>

        <input
          *ngIf="!isCardDisabled(item.issueName)"
          type="checkbox"
          class="issues-filter-card-checkbox accent-blue w-5 h-5"
          [checked]="isIssueSelected(item.issueName)"
          (change)="
            onIssueSelectionChange(item.issueName, $any($event.target).checked)
          "
        />
      </section>

      <section class="issues-filter-card-body flex justify-start items-center">
        <span class="issues-filter-card-issue-name text-sm">
          {{ item.issueName }}
        </span>
      </section>
    </div>
  </div>
</section>


<ng-template #issuesFilterSkeleton>
  <section
    id="issues-filter-skeleton"
    class="flex justify-between items-center w-full box-border gap-6 animate-pulse"
  >
    <div
      *ngFor="let card of [1,2,3,4]"
      class="p-4 rounded-lg flex-1 bg-slate-200"
    >
      <div class="flex flex-col gap-3">
        <!-- Header -->
        <section class="flex justify-between items-center">
          <div class="h-8 w-16 bg-slate-300 rounded"></div>
          <div class="h-5 w-5 bg-slate-300 rounded"></div>
        </section>

        <!-- Issue Name -->
        <section>
          <div class="h-4 w-3/4 bg-slate-300 rounded"></div>
        </section>
      </div>
    </div>
  </section>
</ng-template>